import { useMutation } from '@tanstack/vue-query';
import { downloadVulnerabilityImage } from './vulnerability.endpoints';
import { TDownloadVulnerabilityImagePayload } from '../models/types';

export function useDownloadVulnerabilityImage() {
  return useMutation({
    mutationFn: (payload: TDownloadVulnerabilityImagePayload) =>
      downloadVulnerabilityImage(payload),
  });
}
